import { render, staticRenderFns } from "./ChannelTypes.vue?vue&type=template&id=5edd1251&"
import script from "./ChannelTypes.vue?vue&type=script&lang=ts&"
export * from "./ChannelTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelTypes.vue"
export default component.exports